import { create } from 'zustand'
import { moduleService } from '../services'

export const useModuleStore = create((set, get) => ({
  modules: [],
  currentModule: null,
  loading: false,
  error: null,

  // Fetch all modules
  fetchModules: async () => {
    set({ loading: true, error: null })
    try {
      const data = await moduleService.getAll()
      set({ modules: data.modules || data, loading: false })
    } catch (error) {
      set({ 
        error: error.response?.data?.message || 'Failed to fetch modules', 
        loading: false 
      })
    }
  },

  // Fetch single module
  fetchModule: async (id) => {
    set({ loading: true, error: null })
    try {
      const data = await moduleService.getById(id)
      set({ currentModule: data.module || data, loading: false })
    } catch (error) {
      set({ 
        error: error.response?.data?.message || 'Failed to fetch module', 
        loading: false 
      })
    }
  },

  // Clear current module
  clearCurrentModule: () => {
    set({ currentModule: null })
  },

  // Get module by code
  getModuleByCode: (code) => {
    const { modules } = get()
    return modules.find(m => m.code === code)
  },

  // Get module by ID
  getModuleById: (id) => {
    const { modules } = get()
    return modules.find(m => m.id === id)
  },
}))
